// Normalizes Stripe Checkout success redirects for HashRouter.
//
// create-checkout uses success URL `/?session_id={CHECKOUT_SESSION_ID}#/` so the first
// route is `/`. We then replace with `#/thank-you`. If Stripe or the host still puts
// `session_id` inside the hash, we read it from there too.

import { useLayoutEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const STRIPE_SESSION_RE = /^cs_(live|test)_[A-Za-z0-9]+$/;

export default function StripeCheckoutReturnHandler() {
  const navigate = useNavigate();
  const location = useLocation();

  useLayoutEffect(() => {
    const querySid = new URLSearchParams(location.search).get("session_id");

    const hashRaw = (window.location.hash || "#").replace(/^#/, "") || "/";
    const hashQs = hashRaw.includes("?") ? hashRaw.slice(hashRaw.indexOf("?") + 1) : "";
    const hashSid = new URLSearchParams(hashQs).get("session_id");

    const sid = querySid || hashSid;
    if (!sid || !STRIPE_SESSION_RE.test(sid)) return;

    if (location.pathname === "/thank-you") return;

    navigate("/thank-you", { replace: true });
  }, [location.pathname, location.search, navigate]);

  return null;
}
